import {
  openSuccessfullyAddedNotification,
  openSuccessfullyUpdatedNotification,
  openSuccessfullyDeletedNotification,
  openFailedAdditionNotification,
  openFailedUpdationNotification,
  openFailedDeletionNotification,
  openSuccessfulCustomNotification,
  openWarningCustomNotification,
  openFailedWithScreenshotNotification,
  openFailedCustomNotification
} from '@/utils/notification';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('successfullyAddedNotification', openSuccessfullyAddedNotification);
  nuxtApp.provide('successfullyUpdatedNotification', openSuccessfullyUpdatedNotification);
  nuxtApp.provide('successfullyDeletedNotification', openSuccessfullyDeletedNotification);
  nuxtApp.provide('successfulCustomNotification', openSuccessfulCustomNotification);
  nuxtApp.provide('warningCustomNotification', openWarningCustomNotification);
  nuxtApp.provide('failedAddNotification', openFailedAdditionNotification);
  nuxtApp.provide('failedUpdateNotification', openFailedUpdationNotification);
  nuxtApp.provide('failedDeleteNotification', openFailedDeletionNotification);
  nuxtApp.provide('failedWithScreenshotNotification', openFailedWithScreenshotNotification);
  nuxtApp.provide('failedCustomNotification', openFailedCustomNotification);
});
